export default __webpack_public_path__ + "static/media/withdrawimg.0eb6ddf1.svg";